export default class ContactModel {
  constructor(contactId, firstName, lastName) {
    this.contactMapId = null
    this.contactId = contactId
    this.title = ''
    this.firstName = firstName
    this.lastName = lastName
    this.isDefault = false
    this.addresses = []
    this.phones = []
    this.emails = []
    this.remarks = {}
  }
}
